import Link from 'next/link';

export default function StaffHomePage() {
  return (
    <section>
      <p className="text-sm font-medium text-forest-700">Staff home</p>
      <h1 className="mt-2 text-2xl font-bold text-slate-900">Your staff workspace</h1>
      <p className="mt-3 text-slate-600">Your schedule, clock, and hours for the store selected above.</p>
      <div className="mt-6 grid gap-4 sm:grid-cols-3">
        {[
          ['/staff/schedule', 'My schedule', 'See your published shifts.'],
          ['/staff/clock', 'Clock', 'Clock in or out and record breaks.'],
          ['/staff/hours', 'My hours', 'Review your own timesheets.'],
        ].map(([href, title, description]) => (
          <Link key={href} href={href} className="rounded-lg border border-slate-200 bg-white p-5 hover:border-forest-600 focus-visible:outline-2">
            <h2 className="font-semibold text-forest-700">{title}</h2>
            <p className="mt-2 text-sm text-slate-600">{description}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}
